// extracted by mini-css-extract-plugin
export default {"tts-box":"TTSSetting_tts-box__7KuCf","top":"TTSSetting_top__3nc1x","mid":"TTSSetting_mid__e7BHS"};